(function () {
    'use strict';

    a3_cabin_reports.directive('crewPreviousInfo', crewPreviousInfo);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name crewPreviousInfo
    * @restrict E
    * @description
    *   Crew Table with a double row per crew member showing previous duty info
    * @example
    *   Usage:
    *     <crew-previous-info crew="flight.crew" type="'flight'"></crew-previous-info>
    * @ngInject
    */
    function crewPreviousInfo($uibModal, UserFactory) {
        function link(scope, element, attrs) {
            scope.user = UserFactory.getUser();
            scope.filterByPreviousDuty =  filterByPreviousDuty;

            if(scope.type=="flight"){
                scope.crewMembers = scope.crew.filter(x => (x.position =='CP' || x.position == "FO") && !x.isDHC );
            }
            else if(scope.type=="cabin"){
                scope.crewMembers = scope.crew.filter(x => (x.position =='SA' || x.position == "FA") && !x.isDHC );
            }
            else{
                scope.crewMembers = scope.crew.filter(x => x.isDHC );
            }

            function filterByPreviousDuty(){
                return function( crew ) {
                    return crew.PreviousDuty && crew.PreviousDuty.isDifferent;
                };
            }
        }

        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/CrewInfo/crewPreviousInfo.tpl.html',
            scope: {crew:"=", type:"="},
            link: link
        }
    }

})();
